module.exports = __webpack_public_path__ + "static/img/15.72b874a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/15.png
// module id = hBMw
// module chunks = 0